<template>
    <div>
      <Drawer
        v-model="visible"
        :width="width"
        id="project"
        title=""
        @on-visible-change="drawerChange"
        :closable="false"
        :footer-hide="true"
        :before-close="beforeClose"
        >
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="close"><Icon type="md-arrow-back" size="16" /></a> &nbsp;采购项目及订单</h5>
        </div>
        <Input v-model="params.project_name" placeholder="项目名称" style="width:90px;" @on-enter="fetchData"/>
        <DatePicker @on-change="projectDateChange" format="yyyy" type="year" placeholder="时间" style="width: 70px"></DatePicker>
        <Button icon="md-search" @click="fetchData"></Button>
        <Divider type="vertical" />
        <Button @click="openProjectDrawer" type="primary" icon="md-create" :disabled="!this.$menu.isPower('contract', 'project_edit')">添加项目</Button>
        <Divider />
        <Spin v-if="loading">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Tree v-else :data="projectData" :render="renderContent" style="margin-bottom:15px"></Tree>
      </Drawer>
      <Drawer
        v-model="addProjectVisible"
        :width="width">
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="addProjectVisible=false"><Icon type="md-arrow-back" size="16" /></a> &nbsp;{{projectForm.id==0?'添加':'编辑'}}项目</h5>
        </div>
        <Form :model="projectForm" ref="projectForm" :rules="ruleValidate" label-position="top">
            <FormItem label="关联项目" prop="number">
              <Select v-model="projectForm.project_id" placeholder="选择项目组" >
                <template v-for="(item, ind) in $store.state.department">
                  <OptionGroup :label="item.label" :key="ind" v-if="item.value==department_id">
                    <Option v-for="(child, i) in item.children" :key="i" :value="child.value" :label="child.label"/>
                  </OptionGroup>
                </template>
              </Select>
            </FormItem>
            <FormItem label="项目时间" prop="project_date">
                <DatePicker v-model="projectForm.project_date" format="yyyy-MM" type="month" placeholder="Select date" style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="项目编号" prop="project_number">
                <Input v-model="projectForm.project_number" placeholder="项目编号"/>
            </FormItem>
            <FormItem label="项目名称" prop="project_name">
                <Input v-model="projectForm.project_name" placeholder="请输入项目名称"/>
            </FormItem>
            <FormItem label="">
              <Button type="success" :disabled="this.submitDis" long @click="saveProject">确定</Button>
            </FormItem>
        </Form>
      </Drawer>
      <Drawer
        v-model="addOrderVisible"
        :width="width">
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="addOrderVisible=false"><Icon type="md-arrow-back" size="16" /></a> &nbsp;{{orderForm.id==0?'添加':'编辑'}}采购单</h5>
        </div>
        <Form :model="orderForm" ref="projectOrderForm" :rules="ruleOrderValidate" label-position="top">
            <FormItem label="订单编号" prop="order_number">
                <Input v-model="orderForm.order_number" placeholder="请输入编号"/>
            </FormItem>
            <FormItem label="下单时间" prop="order_date">
                <DatePicker v-model="orderForm.order_date" format="yyyy-MM-dd" type="date" placeholder="Select date" style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="工时合计" prop="order_time">
                <Input v-model="orderForm.order_time" placeholder="请输入工时合计"/>
            </FormItem>
            <FormItem label="订单金额" prop="order_price">
              <Input v-model="orderForm.order_price" placeholder="请输入订单金额"/>
            </FormItem>
            <FormItem label="订单服务地点" prop="order_address">
                <Input v-model="orderForm.order_address" placeholder="请输入订单服务地点"/>
            </FormItem>
            <FormItem label="图片" prop="order_file">
              <UploadComponent v-model="orderForm.order_file" :uploading.sync="uploading" :fileList="orderForm.order_file" v-if="addOrderVisible"/>
            </FormItem>
            <FormItem label="">
              <Button type="success" :disabled="this.submitDis" :loading="uploading" long @click="saveOrder">确定</Button>
            </FormItem>
        </Form>
      </Drawer>
      <Drawer
        v-model="addConfirmVisible"
        :width="width">
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="addConfirmVisible=false"><Icon type="md-arrow-back" size="16" /></a> &nbsp;{{confirmForm.id==0?'添加':'编辑'}}确认单</h5>
        </div>
        <Form :model="confirmForm" ref="confirmForm" :rules="ruleConfirmValidate" label-position="top">
          <FormItem label="确认订单编号" prop="confirm_number">
              <Input v-model="confirmForm.confirm_number" placeholder="请输入确认订单编号"/>
          </FormItem>
          <FormItem label="确认单时间" prop="confirm_date">
              <DatePicker v-model="confirmForm.confirm_date" format="yyyy-MM-dd" type="date" placeholder="Select date" style="width: 200px"></DatePicker>
          </FormItem>
          <FormItem label="确认工时合计" prop="confirm_time">
              <Input v-model="confirmForm.confirm_time" placeholder="请输入工时合计"/>
          </FormItem>
          <FormItem label="确认订单金额" prop="confirm_price">
            <Input v-model="confirmForm.confirm_price" placeholder="请输入确认订单金额"/>
          </FormItem>
          <FormItem label="开票金额" prop="invoice_price" v-if="confirmForm.id > 0">
            <Card :shadow="true" style="background:#eee">
              <Row :gutter="5" style="border-bottom:1px solid #ccc;font-size:12px">
                <Col span="10">开票金额</Col>
                <Col span="10">开票时间</Col>
                <Col span="4">操作</Col>
              </Row>
              <Row :gutter="5" style="border-bottom:1px solid #ccc;margin-bottom:10px" v-for="(invoice, ind) in confirmForm.invoice" :key="ind">
                <Col span="10">¥ {{invoice.price}}</Col>
                <Col span="10">{{invoice.date}}</Col>
                <Col span="4">
                  <Tooltip content="编辑" placement="top">
                    <Button icon="md-create" @click="editInvoice(invoice)" type="info" size="small"/>
                  </Tooltip>
                  <Tooltip :content="invoice.status==1?'已到款':'确认到款'" placement="top">
                    <Button icon="md-checkmark" @click="okInvoice(invoice.id, ind)" :disabled="invoice.status==1" type="success" size="small"/>
                  </Tooltip>
                  <Tooltip content="删除" placement="top">
                    <Button icon="md-close" @click="delInvoice(invoice, ind)" type="error" size="small"/>
                  </Tooltip>
                </Col>
              </Row>
              <Row v-if="confirmForm.invoice.length==0">
                <Col span="24">暂无数据</Col>
              </Row>
              <Row v-if="!invoiceFormVisible">
                <Col span="24"><Button icon="md-add" size="small" @click="addInvoice(confirmForm.id, confirmForm.contract_order_id)" long></Button></Col>
              </Row>
              <Row :gutter="5" style="background:#fff;padding:5px;border-radius:4px" v-if="invoiceFormVisible">
                <Col span="10"><Input v-model="invoiceForm.price" placeholder="开票金额"/></Col>
                <Col span="10"><Input v-model="invoiceForm.date" placeholder="开票时间"/></Col>
                <Col span="4"><Button @click="saveInvoice" size="small">确定</Button> <Button @click="invoiceFormVisible=false" size="small">取消</Button></Col>
              </Row>
            </Card>
          </FormItem>
          <FormItem label="满意度得分" prop="confirm_score">
              <Input v-model="confirmForm.confirm_score" placeholder="请输入满意度得分"/>
          </FormItem>
          <FormItem label="图片" prop="confirm_file">
            <UploadComponent v-model="confirmForm.confirm_file" :uploading.sync="uploading" :fileList="confirmForm.confirm_file" v-if="addConfirmVisible"/>
          </FormItem>
          <FormItem label="">
            <Button type="success" :disabled="this.submitDis" :loading="uploading" long @click="saveConfirm">确定</Button>
          </FormItem>
        </Form>
      </Drawer>
    </div>
</template>

<script>
  import {fetch, del, post, put} from '../fetch/api'
  import {formatTime} from '../util/filter'
  const baseDate = {
    edu_exp: {time: '', con: '', edu: '', major: ''},
    work_exp: {time: '', unit: '', post: '', reason: '', detail: ''},
    certificate: {name: '', time: '', unit: '', redord: '是'},
    contact: {name: '', relation: '', address: '', tel: '', email: ''},
    family: {name: '', relation: '', tel: '', unit: ''}
  }
  const projectDefault = {
    id: 0,
    project_date: '',
    project_id: 0,
    contract_id: 0,
    project_name: '',
    project_number: ''
  }
  const orderDefault = {
    id: 0,
    contract_project_id: 0,
    order_file: [],
    order_number: '',
    order_date: '',
    order_time: '',
    order_price: '',
    order_address: ''
  }
  const confirmDefault = {
    id: 0,
    contract_order_id: 0,
    confirm_file: [],
    invoice: [],
    confirm_score: '',
    confirm_date: '',
    confirm_time: '',
    confirm_price: ''
  }

  export default {
    name: 'ContractOrder',
    components: {
      UploadComponent: resolve => { require(['./UploadComponent'], resolve) }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      contract_id: Number,
      department_id: Number,
      data: {
        type: Object
      }
    },
    data () {
      let token = localStorage.getItem('token')

      return {
        entry_info: '',
        uploading: false,
        loading: false,
        uploadApiPath: '/api/biding/avatar',
        defaultList: [
          {
            'name': 'a42bdcc1178e62b4694c830f028db5c0',
            'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
          }
        ],
        token: token,
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        width: window.innerWidth <= 640 ? 100 : 640,
        submitDis: false,
        addProjectVisible: false,
        addOrderVisible: false,
        addConfirmVisible: false,
        projectForm: JSON.parse(JSON.stringify(projectDefault)),
        orderForm: JSON.parse(JSON.stringify(orderDefault)),
        confirmForm: JSON.parse(JSON.stringify(confirmDefault)),
        projectData: [],
        params: {
          project_name: null
        },
        ruleValidate: {
          project_number: [
            { required: true, message: '请输入项目编号', trigger: 'blur' }
          ],
          project_name: [
            { required: true, message: '请输入项目名称', trigger: 'blur' }
          ]
          // contract_price: [
          //   { type: 'number', message: '合同金额格式不对', trigger: 'blur' }
          // ]
        },
        ruleOrderValidate: {
          order_number: [
            { required: true, message: '请输入订单编号', trigger: 'blur' }
          ],
          order_time: [
            { required: true, message: '请输入工时', trigger: 'blur' }
          ],
          order_price: [
            { required: true, message: '请输入订单金额', trigger: 'blur' }
          ]
        },
        ruleConfirmValidate: {
          confirm_number: [
            { required: true, message: '请输入确认订单编号', trigger: 'blur' }
          ],
          confirm_time: [
            { required: true, message: '请输入确认工时', trigger: 'blur' }
          ],
          confirm_price: [
            { required: true, message: '请输入确认金额', trigger: 'blur' }
          ]
        },
        invoiceFormVisible: false,
        invoiceForm: {
          id: 0,
          confirm_id: 0,
          price: '',
          date: ''
        }
      }
    },
    mounted () {
      // this.fetchData()
    },
    destroyed () {
    },
    methods: {
      projectDateChange (date) {
        this.params.project_date = date
        this.fetchData()
      },
      fetchData () {
        fetch(`/contract/project/${this.contract_id}`, {params: this.params}).then(res => {
          this.formatData(res)
        })
      },
      drawerChange (val) {
        this.loading = true
        if (val) {
          this.fetchData()
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      },
      openProjectDrawer () {
        this.addProjectVisible = true
        this.projectForm = JSON.parse(JSON.stringify(projectDefault))
      },
      beforeClose () {
        return new Promise(() => {
          this.close()
        })
      },
      close () {
        this.$emit('update:visible', false)
      },
      getImage (path) {
        return path ? `/api/console/file?path=${path}&token=${this.token}` : null
      },
      saveProject () {
        this.submitDis = true
        this.$refs.projectForm.validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.projectForm))
            data.project_date = formatTime(new Date(data.project_date), 'yyyy-MM-dd')
            data.contract_id = this.contract_id
            post(`/contract/project`, data).then(res => {
              if (res.status === 'ok') {
                this.$Message.success(res.msg)
                this.fetchData()
                this.addProjectVisible = false
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
        setTimeout(() => {
          this.submitDis = false
        }, 10000)
      },
      saveOrder () {
        this.submitDis = true
        this.$refs.projectOrderForm.validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.orderForm))
            data.order_date = formatTime(new Date(data.order_date), 'yyyy-MM-dd')
            data.order_file = data.order_file.join(',')
            post(`/contract/order`, data).then(res => {
              if (res.status === 'ok') {
                this.$Message.success(res.msg)
                this.fetchData()
                this.addOrderVisible = false
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
        setTimeout(() => {
          this.submitDis = false
        }, 10000)
      },
      saveConfirm () {
        this.submitDis = true
        this.$refs.confirmForm.validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.confirmForm))
            data.confirm_date = formatTime(new Date(data.confirm_date), 'yyyy-MM-dd')
            data.confirm_file = data.confirm_file.join(',')
            post(`/contract/confirm`, data).then(res => {
              if (res.status === 'ok') {
                this.$Message.success(res.msg)
                this.fetchData()
                this.addConfirmVisible = false
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
        setTimeout(() => {
          this.submitDis = false
        }, 10000)
      },
      handleFileChange (e) {
        if (typeof e.target === 'undefined') {
          this.file = e[0]
        } else {
          this.file = e.target.files[0]
        }
        let size = Math.floor(this.file.size / 1024)
        if (size > this.maxSize) {
          this.$Message.error(`文件大小不能超过${this.maxSize}KB`)
          return false
        }
        this.previewImage(this.file)
      },
      previewImage (file) {
        let _this = this
        _this.isSubmit = false
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return
        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader()
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onload = function () {
            let img = new Image()
            img.onload = function () {
              let $canvas = document.getElementById('canvasView')
              let $ctx = $canvas.getContext('2d')
              let w = 100 * 4
              let h = 144 * 4
              $ctx.clearRect(0, 0, w, h)
              $ctx.drawImage(img, 0, 0, w, h)

              _this.data.avatar = $canvas.toDataURL()
            }
            img.src = this.result
          }
        }
      },
      addItem (name) {
        const item = JSON.parse(JSON.stringify(baseDate[name]))
        this.data[name].push(item)
      },
      // removeItem (item, index) {
      //   item.splice(item.indexOf(item[index]), true)
      // },
      removeProject (id) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定要删除该内容吗？',
          onOk: () => {
            let path = `/contract/project/${id}`
            del(path).then(res => {
              res.status === 'ok' ? this.$Message.success(res.msg) : this.$Message.error(res.msg)
              if (res.status === 'ok') {
                this.fetchData()
              }
            })
          }
        })
      },
      remove (data) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定要删除该内容吗？',
          onOk: () => {
            let path = data.isConfirmOrder ? `/contract/confirm/${data.id}` : `/contract/order/${data.id}`
            del(path).then(res => {
              res.status === 'ok' ? this.$Message.success(res.msg) : this.$Message.error(res.msg)
              if (res.status === 'ok') {
                this.fetchData()
              }
            })
          }
        })
      },
      renderContent (h, { data }) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', {style: {color: data.type === 'tips' ? '#ccc' : '#666'}}, [
            h('Icon', {
              props: {
                type: 'ios-paper-outline'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h('span', {
              on: {
                click: () => {
                  let tmp = JSON.parse(JSON.stringify(data))
                  if (tmp.isConfirmOrder) {
                    tmp.confirm_file = !tmp.confirm_file ? [] : tmp.confirm_file.split(',')
                    this.confirmForm = {
                      id: tmp.id,
                      invoice: tmp.invoice,
                      contract_order_id: tmp.contract_order_id,
                      confirm_file: tmp.confirm_file,
                      confirm_number: tmp.confirm_number,
                      confirm_date: tmp.confirm_date,
                      confirm_time: tmp.confirm_time,
                      confirm_price: tmp.confirm_price,
                      confirm_score: tmp.confirm_score
                    }

                    this.addConfirmVisible = true
                  } else {
                    tmp.order_file = !tmp.order_file ? [] : tmp.order_file.split(',')
                    this.orderForm = {
                      id: tmp.id,
                      contract_project_id: tmp.contract_project_id,
                      order_file: tmp.order_file,
                      order_number: tmp.order_number,
                      order_date: tmp.order_date,
                      order_time: tmp.order_time,
                      order_price: tmp.order_price,
                      order_address: tmp.order_address
                    }
                    this.addOrderVisible = true
                  }
                }
              }
            }, [
              h('span', data.title),
              data.type === 'tips' ? null : h('Button', {
                props: {size: 'small', type: 'text', icon: 'ios-create-outline'}
              })
            ])
          ]),
          data.type === 'tips' ? null : h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '15px'
            }
          }, [
            data.isConfirmOrder ? null : h('Button', {
              props: Object.assign({}, this.buttonProps, {
                icon: 'md-checkmark-circle-outline',
                type: 'warning',
                disabled: !this.$menu.isPower('contract', 'confirm_edit'),
                ghost: true,
                size: 'small'
              }),
              style: {
                marginRight: '8px'
              },
              on: {
                click: () => {
                  this.addConfirmVisible = true
                  this.confirmForm = JSON.parse(JSON.stringify(confirmDefault))
                  this.confirmForm.contract_order_id = data.id
                }
              }
            }, '添加确认单'),
            h('Button', {
              props: Object.assign({}, this.buttonProps, {
                icon: 'md-trash',
                disabled: !this.$menu.isPower('contract', 'confirm_edit'),
                size: 'small'
              }),
              on: {
                click: () => { this.remove(data) }
              }
            })
          ])
        ])
      },
      formatData (datas) {
        for (var key in datas) {
          if (datas.hasOwnProperty(key)) {
            datas[key]['expand'] = true
            datas[key]['render'] = (h, { data }) => {
              return h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%'
                }
              }, [
                h('span', [
                  h('Icon', {
                    props: {
                      type: 'ios-briefcase-outline',
                      size: 'small'
                    },
                    style: {
                      marginRight: '8px'
                    }
                  }),
                  h('span', {
                    on: {
                      click: () => {
                        // let tmp = JSON.parse(JSON.stringify(data))
                        this.addProjectVisible = true
                        this.projectForm = data
                      }
                    }
                  }, [
                    h('span', data.title),
                    h('Button', {
                      props: {size: 'small', type: 'text', icon: 'md-create'}
                    })
                  ])
                ]),
                h('span', {
                  style: {
                    display: 'inline-block',
                    float: 'right',
                    marginRight: '15px'
                  }
                }, [
                  h('Button', {
                    props: Object.assign({}, this.buttonProps, {
                      icon: 'md-add',
                      type: 'primary',
                      disabled: !this.$menu.isPower('contract', 'order_edit'),
                      ghost: true,
                      size: 'small'
                    }),
                    style: {
                      marginRight: '8px'
                    },
                    on: {
                      click: () => {
                        this.addOrderVisible = true
                        this.orderForm = JSON.parse(JSON.stringify(orderDefault))
                        this.orderForm.contract_project_id = data.id
                      }
                    }
                  }, '添加采购单'),
                  h('Button', {
                    props: Object.assign({}, this.buttonProps, {
                      icon: 'md-trash',
                      disabled: !this.$menu.isPower('contract', 'order_edit'),
                      size: 'small'
                    }),
                    on: {
                      click: () => { this.removeProject(data.id) }
                    }
                  })
                ])
              ])
            }
            let children = datas[key].children
            if (children.length > 0) {
              for (var k in children) {
                datas[key].children[k].expand = true
                datas[key].children[k].title = '[' + children[k].order_address + ']' + children[k].order_number
                datas[key].children[k].price = children[k].order_price
                let child = children[k].children
                if (child.length > 0) {
                  for (var i in child) {
                    datas[key].children[k].children[i].expand = true
                    datas[key].children[k].children[i].isConfirmOrder = true
                    datas[key].children[k].children[i].title = child[i].confirm_number
                    datas[key].children[k].children[i].price = child[i].confirm_price
                  }
                } else {
                  datas[key].children[k].children.push({expand: true, title: '还没有确认单', type: 'tips'})
                }
              }
            } else {
              datas[key].children.push({expand: true, title: '还没有采购订单', type: 'tips'})
            }
          }
        }
        this.projectData = datas
      },
      addInvoice (confirmId, orderId) {
        this.invoiceFormVisible = true
        this.invoiceForm = {
          id: 0,
          contract_order_id: orderId,
          confirm_id: confirmId,
          price: '',
          date: ''
        }
      },
      editInvoice (data) {
        this.invoiceFormVisible = true
        this.invoiceForm = {
          id: data.id,
          contract_order_id: data.contract_order_id,
          confirm_id: data.confirm_id,
          price: data.price,
          date: data.date
        }
      },
      okInvoice (id, ind) {
        this.$Modal.confirm({
          title: '到款确认',
          content: '确定设置为已到款？',
          onOk: () => {
            put(`/contract/invoice/${id}/status/1`).then(res => {
              res.status === 'ok' ? this.$Message.success(res.msg) : this.$Message.error(res.msg)
              if (res.status === 'ok') {
                this.confirmForm.invoice[ind] = 1
              }
            })
          }
        })
      },
      delInvoice (data, ind) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定要删除该内容吗？',
          onOk: () => {
            let path = `/contract/invoice/${data.id}`
            del(path).then(res => {
              res.status === 'ok' ? this.$Message.success(res.msg) : this.$Message.error(res.msg)
              if (res.status === 'ok') {
                this.confirmForm.invoice.splice(ind, 1)
                this.fetchData()
              }
            })
          }
        })
      },
      saveInvoice () {
        let data = JSON.parse(JSON.stringify(this.invoiceForm))
        this.invoiceFormVisible = false
        post(`/contract/invoice`, data).then(res => {
          if (res.status === 'ok') {
            this.$Message.success(res.msg)
            this.invoiceFormVisible = false
            this.fetchData()
            this.confirmForm.invoice.push(res.data)
          } else {
            this.$Message.error({
              content: res.msg,
              duration: 5
            })
          }
        })
        .catch(res => {
          this.$Message.error(res.msg)
        })
      }
    }
  }
</script>
<style>
  .apps-entry-table .ivu-table-cell{padding:0 6px;}
  .apps-entry-table:after{display: none;}
  .apps-entry-table .ivu-form-item{margin:0 auto;}
  .apps-entry-table .ivu-form-item-error-tip{top:5px;right:5px;left:auto;}
  .apps-entry-table.ivu-table:before{display: none;}
  .apps-entry-table th{width:80px;text-align: right}
  .apps-entry-steps.ivu-steps .ivu-steps-head,
  .apps-entry-steps.ivu-steps .ivu-steps-title{background: none;}
  .pos-staic .ivu-form-item-content{position: static;}
</style>
<style scoped>
  .spin-icon-load{
    animation: ani-spin 1s linear infinite;
  }
  @keyframes ani-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .avatar-file{display: none}
  .apps-entry-steps{width:180px;float:left;padding-top:20px;}
  .apps-entry{
    width: 1030px;
    height: 100%;
    margin: 40px auto 0;

  }
  .apps-entry-content{
    margin-left: 190px;
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    min-height: 400px;
    margin-bottom: 40px;
    position: relative;
  }
  .apps-entry-title{
    margin-bottom: 10px;
  }
  .apps-entry-steps-buttons{
    padding: 5px 34px;
  }
  .rules-head{
    border-bottom: 1px solid #eee;
    padding:20px 20px 10px;
  }
  .rules-foot{
    width: 100%;
    padding: 20px 0;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
  }
  .rules-content{
    padding: 10px 20px 100px;
    border-width: 1px 0;
  }
  .rules-content h4{margin:10px 0;color:#666;}
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .upload-box{margin-bottom: 20px;}
  .upload-item{
    width:256px;
    display: inline-block;
    margin-left: 15px;
  }
  .upload-item-wrap{
    width: 256px;
    height: 160px;
    overflow: hidden;
    background-color: #f7f7f7
  }
  .upload-item-img,
  .upload-item-img img{height: 100%}
  .upload-item-cover{
    width: 100%;
    font-size:18px;
    color:#999;
    line-height: 40px;
    position: absolute;
    top: 60px;
  }
  .upload-item-cover i{vertical-align: middle;color:#999;}
  .contract-down{padding-top:20px;text-align: center}
  .contract-item{width:140px;display:inline-block;text-align: center;vertical-align: top;margin:0 10px;}
  .contract-item .ivu-icon{
    width: 140px;
    padding: 20px 0;
    font-size: 60px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center;
    background-color: #f1f1f1;
    margin-bottom: 10px;
  }
  .rules-book p{
    text-indent: 2em;
    color: #666;
    line-height: 2
  }
</style>
